@let canGoBack = canShiftBack();
@let canGoForward = canShiftForward();
<div
  class="flex flex-row justify-between pb-3"
  [id]="id() | appendTestId: 'month-picker'">
  <span
    [id]="id() | appendTestId: 'previous-month'"
    [attr.data-testid]="id() | appendTestId: 'previous-month'"
    tabindex="0"
    class="material-symbols-rounded"
    [ngClass]="{
      'cursor-pointer': canGoBack,
      'pointer-events-none cursor-not-allowed opacity-20': !canGoBack,
    }"
    (keydown.enter)="decreaseMonth()"
    (click)="decreaseMonth()"
    >chevron_left</span
  >
  <div
    class="flex flex-row"
    [id]="id() | appendTestId: 'month-and-year'"
    [attr.data-testid]="id() | appendTestId: 'month-and-year'">
    <div
      class="pr-2"
      [id]="id() | appendTestId: 'month'"
      [attr.data-testid]="id() | appendTestId: 'month'">
      {{
        textStore.texts()
          | filterTexts: month() : EEntityType.generic
          | language
      }}
    </div>
    <aw-year-picker
      [id]="id()"
      [date]="date()"
      [shownYear]="shownYear()"
      (onYearChange)="onYearChange.emit($event)"
      [min]="min()"
      [max]="max()"
      [restrictedDateList]="restrictedDateList()"></aw-year-picker>
  </div>
  <span
    [id]="id() | appendTestId: 'next-month'"
    [attr.data-testid]="id() | appendTestId: 'next-month'"
    tabindex="0"
    class="material-symbols-rounded"
    [ngClass]="{
      'cursor-pointer': canGoForward,
      'pointer-events-none cursor-not-allowed opacity-20': !canGoForward,
    }"
    (keydown.enter)="increaseMonth()"
    (click)="increaseMonth()"
    >chevron_right</span
  >
</div>
